import React from "react";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { UserActivityModule } from "./UserActivityModule";

const UserActivity = (props) => {
  const { notifications } = props;

  return (
    <ErrorBoundary moduleName="userActivityModule" {...notifications}>
      <UserActivityModule />
    </ErrorBoundary>
  );
};

export default UserActivity;
